export const translations = {
  en: {
    // Header Navigation
    header: {
      research: 'Research',
      services: 'Services',
      products: 'Products',
      news: 'News',
      about: 'About us',
      contact: 'Contact',
      researchAreas: 'Research Areas',
      euProjects: 'EU-Funded Projects'
    },
    
    // Home Page
    home: {
      heroTitle: 'Advancing AI for Healthcare Innovation',
      heroSubtitle: 'Leading research institute developing cutting-edge artificial intelligence solutions for healthcare, rehabilitation, and human enhancement.',
      learnMore: 'Learn More',
      ourResearch: 'Our Research',
      seeAll: 'See all',
      getStarted: 'Get Started',
      
      // Hero Section
      heroDescription: 'Pioneering research in artificial intelligence for medical applications, rehabilitation technologies, and human performance enhancement.',
      exploreResearch: 'Explore Research',
      viewProjects: 'View Projects',
      
      // Stats
      stats: {
        publications: 'Research Publications',
        projects: 'Active EU Projects',
        partnerships: 'Clinical Partnerships',
        impact: 'Patient Impact Score'
      },
      
      // Sections
      sections: {
        research: {
          title: 'Our Research',
          subtitle: 'Cutting-edge AI research transforming healthcare',
          description: 'We conduct groundbreaking research in artificial intelligence applications for healthcare, developing innovative solutions that improve patient outcomes and advance medical practice.',
          areas: {
            healthcare: 'Healthcare AI',
            rehabilitation: 'Rehabilitation Technology',
            biomechanics: 'Biomechanical Analysis',
            neuroscience: 'Computational Neuroscience'
          }
        },
        projects: {
          title: 'EU-Funded Projects',
          subtitle: 'Leading European research initiatives',
          description: 'Our team leads and participates in prestigious European Union research programs, collaborating with top institutions across Europe.',
          viewAll: 'View All Projects'
        },
        services: {
          title: 'Our Services',
          subtitle: 'Professional AI solutions for healthcare',
          description: 'We offer comprehensive AI consulting and development services for healthcare organizations, research institutions, and technology companies.',
          consulting: 'AI Consulting',
          development: 'Custom Development',
          training: 'Training & Workshops',
          research: 'Research Collaboration'
        },
        about: {
          title: 'About AI4.GR',
          subtitle: 'Leading AI research institute',
          description: 'Founded by renowned researchers, AI4.GR is at the forefront of artificial intelligence research for healthcare applications.',
          mission: 'Our mission is to advance human health and wellbeing through innovative AI technologies.',
          vision: 'We envision a future where AI enhances every aspect of healthcare delivery and patient care.',
          values: 'Innovation, Excellence, Collaboration, Impact'
        }
      }
    },
    
    // Footer
    footer: {
      company: {
        title: 'AI4.GR',
        description: 'Advancing artificial intelligence for healthcare innovation and human enhancement.',
        rights: 'All rights reserved.'
      },
      links: {
        quickLinks: 'Quick Links',
        research: 'Research',
        projects: 'EU Projects',
        services: 'Services',
        about: 'About',
        contact: 'Contact',
        news: 'News'
      },
      contact: {
        title: 'Contact Info',
        address: 'Address',
        phone: 'Phone',
        email: 'Email',
        followUs: 'Follow Us'
      },
      legal: {
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        cookies: 'Cookie Policy'
      }
    },
    
    // About Page
    about: {
      title: 'About AI4.GR',
      subtitle: 'Leading artificial intelligence research for healthcare innovation',
      mission: {
        title: 'Our Mission',
        description: 'To advance human health and wellbeing through cutting-edge artificial intelligence research and applications.'
      },
      vision: {
        title: 'Our Vision',
        description: 'A future where AI enhances every aspect of healthcare delivery, improving patient outcomes and quality of life.'
      },
      values: {
        title: 'Our Values',
        innovation: 'Innovation',
        excellence: 'Excellence',
        collaboration: 'Collaboration',
        impact: 'Impact'
      },
      team: {
        title: 'Our Team',
        subtitle: 'Meet our world-class researchers and experts'
      }
    },
    
    // Services Page
    services: {
      title: 'Our Services',
      subtitle: 'Professional AI solutions for healthcare and research',
      consulting: {
        title: 'AI Consulting',
        description: 'Expert guidance on AI strategy and implementation'
      },
      development: {
        title: 'Custom Development',
        description: 'Tailored AI solutions for your specific needs'
      },
      training: {
        title: 'Training & Workshops',
        description: 'Educational programs and skill development'
      },
      research: {
        title: 'Research Collaboration',
        description: 'Partnership opportunities for joint research'
      }
    },
    
    // Research Page
    research: {
      title: 'Our Research',
      subtitle: 'Cutting-edge AI research transforming healthcare',
      areas: {
        title: 'Research Areas',
        healthcare: 'Healthcare AI',
        rehabilitation: 'Rehabilitation Technology',
        biomechanics: 'Biomechanical Analysis',
        neuroscience: 'Computational Neuroscience'
      },
      publications: {
        title: 'Publications',
        subtitle: 'Latest research publications and findings'
      }
    },
    
    // Contact Page
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our team',
      form: {
        name: 'Name',
        email: 'Email',
        subject: 'Subject',
        message: 'Message',
        send: 'Send Message'
      },
      info: {
        title: 'Contact Information',
        address: 'Address',
        phone: 'Phone',
        email: 'Email'
      }
    },
    
    // News Page
    news: {
      title: 'Newsroom',
      subtitle: 'Latest updates on our research, partnerships, and innovations in artificial intelligence.',
      breadcrumb: {
        home: 'Home',
        news: 'News',
        article: 'Article'
      },
      backToNews: 'Back to News',
      backToNewsBlog: 'Back to News AI4 Blog',
      latestNews: 'Latest News and Press Releases',
      seeAllNews: 'See all news',
      shareArticle: 'Share this article:',
      twitter: 'Twitter',
      linkedin: 'LinkedIn',
      facebook: 'Facebook',
      references: 'References & Links'
    },
    
    // Article Categories
    categories: {
      research: 'Research',
      euProjects: 'EU Projects',
      events: 'Events'
    },
    
    // Articles
    articles: {
      // Article 1: LEAD YOUR WAY
      leadYourWay: {
        title: 'AI4.GR Leads Digital Inclusion with "LEAD YOUR WAY" Project',
        excerpt: 'Cross-European initiative spanning eight countries tackles employment gaps for individuals with Down syndrome and intellectual disabilities through innovative digital tools.',
        category: 'EU Projects'
      },
      
      // Article 2: STEP-UP
      stepUp: {
        title: 'Empowering Older Adults: STEP‑UP Project Tackles Fall Prevention',
        excerpt: 'Innovative project (2024–2027) develops tailored educational tools and e-learning platforms to help elderly individuals in Greece and Cyprus maintain safety and independence.',
        category: 'EU Projects'
      },
      
      // Article 3: Stroke Rehabilitation
      strokeRehab: {
        title: 'Advancing Stroke Rehabilitation Research',
        excerpt: 'AI4.GR co-founders conduct significant research combining neuroimaging, neurophysiological and biomechanical data with machine learning to understand recovery trajectories.',
        category: 'Research'
      },
      
      // Article 4: Occupational Therapy
      occupationalTherapy: {
        title: 'AI Enhances Occupational Therapy: Insights from a Scoping Review',
        excerpt: 'AI4.GR researchers contribute to comprehensive review examining how artificial intelligence can enhance assessment in occupational therapy through sensor data and pattern recognition.',
        category: 'Research'
      },
      
      // Article 5: Language Recovery
      languageRecovery: {
        title: 'Machine Learning Predicts Language and Cognition Recovery After Stroke',
        excerpt: 'AI4.GR researchers lead comprehensive review achieving up to 97% recall rates in predicting cognitive outcomes using speech, imaging and clinical data.',
        category: 'Research'
      },
      
      // Article 6: Gait Data
      gaitData: {
        title: 'Visualising Gait Data for Better Stroke Diagnosis',
        excerpt: 'AI4.GR-led study explores visual analytics and explainable machine learning to make complex biomechanical data more accessible to clinicians.',
        category: 'Research'
      },
      
      // Article 7: Explainable AI
      explainableAI: {
        title: 'Improving Stroke Outcome Predictions with Explainable AI',
        excerpt: 'AI4.GR researchers develop explainable machine-learning pipeline addressing data imbalance challenges while providing transparent clinical predictions.',
        category: 'Research'
      },
      
      // Article 8: Dementia Movement
      dementiaMovement: {
        title: 'Movement Programmes Boost Mobility for Dementia Patients',
        excerpt: 'Case study involving AI4.GR co-founder Prof. Nikos Aggelousis examines effects of personalised movement programmes on dementia patient gait characteristics.',
        category: 'Research'
      },
      
      // Article 9: ACL Injury
      aclInjury: {
        title: 'Explainable AI Identifies Biomarkers for ACL Injury',
        excerpt: 'AI4.GR researchers co-develop explainable machine learning method achieving 94.95% accuracy in analyzing gait patterns for ACL injury risk factors.',
        category: 'Research'
      },
      
      // Article 10: Creative Industries
      creativeIndustries: {
        title: 'AI4.GR Engages Creative Industries at AI X Thessaloniki',
        excerpt: 'Co-founder Dr Serafeim Moustakidis speaks at prestigious conference exploring how generative AI will reshape creative industries.',
        category: 'Events'
      }
    },
    
    // Common
    common: {
      readMore: 'Read More',
      learnMore: 'Learn More',
      getStarted: 'Get Started',
      contactUs: 'Contact Us',
      loading: 'Loading...',
      error: 'Error',
      notFound: 'Not Found',
      backToHome: 'Back to Home'
    }
  },
  
  el: {
    // Header Navigation
    header: {
      research: 'Έρευνα',
      services: 'Υπηρεσίες', 
      products: 'Προϊόντα',
      news: 'Νέα',
      about: 'Σχετικά με εμάς',
      contact: 'Επικοινωνία',
      researchAreas: 'Ερευνητικοί Τομείς',
      euProjects: 'Ευρωπαϊκά Προγράμματα'
    },
    
    // Home Page
    home: {
      heroTitle: 'Προηγμένη Τεχνητή Νοημοσύνη για την Καινοτομία στην Υγεία',
      heroSubtitle: 'Κορυφαίο ερευνητικό ινστιτούτο που αναπτύσσει λύσεις τεχνητής νοημοσύνης για την υγειονομική περίθαλψη, αποκατάσταση και ανθρώπινη ενίσχυση.',
      learnMore: 'Μάθετε Περισσότερα',
      ourResearch: 'Η Έρευνά μας',
      seeAll: 'Δείτε όλα',
      getStarted: 'Ξεκινήστε',
      
      // Hero Section
      heroDescription: 'Πρωτοποριακή έρευνα στην τεχνητή νοημοσύνη για ιατρικές εφαρμογές, τεχνολογίες αποκατάστασης και βελτίωση ανθρώπινης απόδοσης.',
      exploreResearch: 'Εξερευνήστε την Έρευνα',
      viewProjects: 'Δείτε τα Προγράμματα',
      
      // Stats
      stats: {
        publications: 'Ερευνητικές Δημοσιεύσεις',
        projects: 'Ενεργά Ευρωπαϊκά Προγράμματα',
        partnerships: 'Κλινικές Συνεργασίες',
        impact: 'Δείκτης Επίδρασης Ασθενών'
      },
      
      // Sections
      sections: {
        research: {
          title: 'Η Έρευνά μας',
          subtitle: 'Προηγμένη έρευνα ΤΝ που μετασχηματίζει την υγειονομική περίθαλψη',
          description: 'Διεξάγουμε πρωτοποριακή έρευνα στις εφαρμογές τεχνητής νοημοσύνης για την υγειονομική περίθαλψη, αναπτύσσοντας καινοτόμες λύσεις που βελτιώνουν τα αποτελέσματα των ασθενών και προωθούν την ιατρική πρακτική.',
          areas: {
            healthcare: 'ΤΝ στην Υγειονομική Περίθαλψη',
            rehabilitation: 'Τεχνολογία Αποκατάστασης',
            biomechanics: 'Βιομηχανική Ανάλυση',
            neuroscience: 'Υπολογιστική Νευροεπιστήμη'
          }
        },
        projects: {
          title: 'Ευρωπαϊκά Προγράμματα',
          subtitle: 'Ηγούμαστε ευρωπαϊκών ερευνητικών πρωτοβουλιών',
          description: 'Η ομάδα μας ηγείται και συμμετέχει σε διακεκριμένα ερευνητικά προγράμματα της Ευρωπαϊκής Ένωσης, συνεργαζόμενη με κορυφαία ιδρύματα σε όλη την Ευρώπη.',
          viewAll: 'Δείτε Όλα τα Προγράμματα'
        },
        services: {
          title: 'Οι Υπηρεσίες μας',
          subtitle: 'Επαγγελματικές λύσεις ΤΝ για την υγειονομική περίθαλψη',
          description: 'Προσφέρουμε ολοκληρωμένες υπηρεσίες συμβουλευτικής και ανάπτυξης ΤΝ για οργανισμούς υγειονομικής περίθαλψης, ερευνητικά ιδρύματα και εταιρείες τεχνολογίας.',
          consulting: 'Συμβουλευτική ΤΝ',
          development: 'Προσαρμοσμένη Ανάπτυξη',
          training: 'Εκπαίδευση & Σεμινάρια',
          research: 'Ερευνητική Συνεργασία'
        },
        about: {
          title: 'Σχετικά με την AI4.GR',
          subtitle: 'Κορυφαίο ινστιτούτο έρευνας ΤΝ',
          description: 'Ιδρυθείσα από διακεκριμένους ερευνητές, η AI4.GR βρίσκεται στην πρωτοπορία της έρευνας τεχνητής νοημοσύνης για εφαρμογές υγειονομικής περίθαλψης.',
          mission: 'Η αποστολή μας είναι να προωθήσουμε την ανθρώπινη υγεία και ευημερία μέσω καινοτόμων τεχνολογιών ΤΝ.',
          vision: 'Οραματιζόμαστε ένα μέλλον όπου η ΤΝ ενισχύει κάθε πτυχή της παροχής υγειονομικής περίθαλψης και φροντίδας ασθενών.',
          values: 'Καινοτομία, Αριστεία, Συνεργασία, Επίδραση'
        }
      }
    },
    
    // Footer
    footer: {
      company: {
        title: 'AI4.GR',
        description: 'Προωθώντας την τεχνητή νοημοσύνη για καινοτομία στην υγειονομική περίθαλψη και ανθρώπινη ενίσχυση.',
        rights: 'Όλα τα δικαιώματα διατηρούνται.'
      },
      links: {
        quickLinks: 'Γρήγοροι Σύνδεσμοι',
        research: 'Έρευνα',
        projects: 'Ευρωπαϊκά Προγράμματα',
        services: 'Υπηρεσίες',
        about: 'Σχετικά',
        contact: 'Επικοινωνία',
        news: 'Νέα'
      },
      contact: {
        title: 'Στοιχεία Επικοινωνίας',
        address: 'Διεύθυνση',
        phone: 'Τηλέφωνο',
        email: 'Email',
        followUs: 'Ακολουθήστε μας'
      },
      legal: {
        privacy: 'Πολιτική Απορρήτου',
        terms: 'Όροι Χρήσης',
        cookies: 'Πολιτική Cookies'
      }
    },
    
    // About Page
    about: {
      title: 'Σχετικά με την AI4.GR',
      subtitle: 'Κορυφαία έρευνα τεχνητής νοημοσύνης για καινοτομία στην υγειονομική περίθαλψη',
      mission: {
        title: 'Η Αποστολή μας',
        description: 'Να προωθήσουμε την ανθρώπινη υγεία και ευημερία μέσω προηγμένης έρευνας και εφαρμογών τεχνητής νοημοσύνης.'
      },
      vision: {
        title: 'Το Όραμά μας',
        description: 'Ένα μέλλον όπου η ΤΝ ενισχύει κάθε πτυχή της παροχής υγειονομικής περίθαλψης, βελτιώνοντας τα αποτελέσματα των ασθενών και την ποιότητα ζωής.'
      },
      values: {
        title: 'Οι Αξίες μας',
        innovation: 'Καινοτομία',
        excellence: 'Αριστεία',
        collaboration: 'Συνεργασία',
        impact: 'Επίδραση'
      },
      team: {
        title: 'Η Ομάδα μας',
        subtitle: 'Γνωρίστε τους παγκοσμίου επιπέδου ερευνητές και ειδικούς μας'
      }
    },
    
    // Services Page
    services: {
      title: 'Οι Υπηρεσίες μας',
      subtitle: 'Επαγγελματικές λύσεις ΤΝ για υγειονομική περίθαλψη και έρευνα',
      consulting: {
        title: 'Συμβουλευτική ΤΝ',
        description: 'Εξειδικευμένη καθοδήγηση σε στρατηγική και υλοποίηση ΤΝ'
      },
      development: {
        title: 'Προσαρμοσμένη Ανάπτυξη',
        description: 'Εξειδικευμένες λύσεις ΤΝ για τις συγκεκριμένες ανάγκες σας'
      },
      training: {
        title: 'Εκπαίδευση & Σεμινάρια',
        description: 'Εκπαιδευτικά προγράμματα και ανάπτυξη δεξιοτήτων'
      },
      research: {
        title: 'Ερευνητική Συνεργασία',
        description: 'Ευκαιρίες συνεργασίας για κοινή έρευνα'
      }
    },
    
    // Research Page
    research: {
      title: 'Η Έρευνά μας',
      subtitle: 'Προηγμένη έρευνα ΤΝ που μετασχηματίζει την υγειονομική περίθαλψη',
      areas: {
        title: 'Ερευνητικοί Τομείς',
        healthcare: 'ΤΝ στην Υγειονομική Περίθαλψη',
        rehabilitation: 'Τεχνολογία Αποκατάστασης',
        biomechanics: 'Βιομηχανική Ανάλυση',
        neuroscience: 'Υπολογιστική Νευροεπιστήμη'
      },
      publications: {
        title: 'Δημοσιεύσεις',
        subtitle: 'Τελευταίες ερευνητικές δημοσιεύσεις και ευρήματα'
      }
    },
    
    // Contact Page
    contact: {
      title: 'Επικοινωνήστε μαζί μας',
      subtitle: 'Έλθετε σε επαφή με την ομάδα μας',
      form: {
        name: 'Όνομα',
        email: 'Email',
        subject: 'Θέμα',
        message: 'Μήνυμα',
        send: 'Αποστολή Μηνύματος'
      },
      info: {
        title: 'Στοιχεία Επικοινωνίας',
        address: 'Διεύθυνση',
        phone: 'Τηλέφωνο',
        email: 'Email'
      }
    },
    
    // News Page
    news: {
      title: 'Δελτίο Τύπου',
      subtitle: 'Τελευταίες ενημερώσεις για την έρευνά μας, τις συνεργασίες και τις καινοτομίες στην τεχνητή νοημοσύνη.',
      breadcrumb: {
        home: 'Αρχική',
        news: 'Νέα',
        article: 'Άρθρο'
      },
      backToNews: 'Επιστροφή στα Νέα',
      backToNewsBlog: 'Επιστροφή στο Blog Νέων AI4',
      latestNews: 'Τελευταία Νέα και Δελτία Τύπου',
      seeAllNews: 'Δείτε όλα τα νέα',
      shareArticle: 'Μοιραστείτε αυτό το άρθρο:',
      twitter: 'Twitter',
      linkedin: 'LinkedIn', 
      facebook: 'Facebook',
      references: 'Αναφορές & Σύνδεσμοι'
    },
    
    // Article Categories
    categories: {
      research: 'Έρευνα',
      euProjects: 'Ευρωπαϊκά Προγράμματα',
      events: 'Εκδηλώσεις'
    },
    
    // Articles
    articles: {
      // Article 1: LEAD YOUR WAY
      leadYourWay: {
        title: 'Η AI4.GR Ηγείται της Ψηφιακής Ένταξης με το Πρόγραμμα "LEAD YOUR WAY"',
        excerpt: 'Διευρωπαϊκή πρωτοβουλία που καλύπτει οκτώ χώρες αντιμετωπίζει τα κενά απασχόλησης για άτομα με σύνδρομο Down και νοητική αναπηρία μέσω καινοτόμων ψηφιακών εργαλείων.',
        category: 'Ευρωπαϊκά Προγράμματα'
      },
      
      // Article 2: STEP-UP
      stepUp: {
        title: 'Ενδυνάμωση Ηλικιωμένων: Το Πρόγραμμα STEP‑UP Αντιμετωπίζει την Πρόληψη Πτώσεων',
        excerpt: 'Καινοτόμο πρόγραμμα (2024–2027) αναπτύσσει εξειδικευμένα εκπαιδευτικά εργαλεία και πλατφόρμες ηλεκτρονικής μάθησης για να βοηθήσει ηλικιωμένους στην Ελλάδα και Κύπρο να διατηρήσουν την ασφάλεια και ανεξαρτησία τους.',
        category: 'Ευρωπαϊκά Προγράμματα'
      },
      
      // Article 3: Stroke Rehabilitation
      strokeRehab: {
        title: 'Προηγμένη Έρευνα στην Αποκατάσταση μετά από Εγκεφαλικό',
        excerpt: 'Οι συνιδρυτές της AI4.GR διεξάγουν σημαντική έρευνα συνδυάζοντας νευροαπεικονιστικά, νευροφυσιολογικά και βιομηχανικά δεδομένα με μηχανική μάθηση για την κατανόηση των τροχιών αποκατάστασης.',
        category: 'Έρευνα'
      },
      
      // Article 4: Occupational Therapy
      occupationalTherapy: {
        title: 'Η Τεχνητή Νοημοσύνη Ενισχύει την Εργοθεραπεία: Αντιλήψεις από Ανασκοπική Μελέτη',
        excerpt: 'Ερευνητές της AI4.GR συνεισφέρουν σε περιεκτική ανασκόπηση που εξετάζει πώς η τεχνητή νοημοσύνη μπορεί να ενισχύσει την αξιολόγηση στην εργοθεραπεία μέσω αισθητηρίων δεδομένων και αναγνώρισης προτύπων.',
        category: 'Έρευνα'
      },
      
      // Article 5: Language Recovery
      languageRecovery: {
        title: 'Η Μηχανική Μάθηση Προβλέπει την Αποκατάσταση Γλώσσας και Γνώσης μετά από Εγκεφαλικό',
        excerpt: 'Ερευνητές της AI4.GR ηγούνται περιεκτικής ανασκόπησης επιτυγχάνοντας ποσοστά ανάκλησης έως 97% στην πρόβλεψη γνωστικών αποτελεσμάτων χρησιμοποιώντας ομιλία, απεικόνιση και κλινικά δεδομένα.',
        category: 'Έρευνα'
      },
      
      // Article 6: Gait Data
      gaitData: {
        title: 'Οπτικοποίηση Δεδομένων Βάδισης για Καλύτερη Διάγνωση Εγκεφαλικού',
        excerpt: 'Μελέτη υπό την ηγεσία της AI4.GR εξερευνά οπτική ανάλυση και επεξηγήσιμη μηχανική μάθηση για να κάνει πολύπλοκα βιομηχανικά δεδομένα πιο προσβάσιμα στους κλινικούς.',
        category: 'Έρευνα'
      },
      
      // Article 7: Explainable AI
      explainableAI: {
        title: 'Βελτίωση Προβλέψεων Αποτελεσμάτων Εγκεφαλικού με Επεξηγήσιμη Τεχνητή Νοημοσύνη',
        excerpt: 'Ερευνητές της AI4.GR αναπτύσσουν επεξηγήσιμη διαδικασία μηχανικής μάθησης που αντιμετωπίζει προκλήσεις ανισορροπίας δεδομένων παρέχοντας διαφανείς κλινικές προβλέψεις.',
        category: 'Έρευνα'
      },
      
      // Article 8: Dementia Movement
      dementiaMovement: {
        title: 'Προγράμματα Κίνησης Ενισχύουν την Κινητικότητα Ασθενών με Άνοια',
        excerpt: 'Μελέτη περίπτωσης που περιλαμβάνει τον συνιδρυτή της AI4.GR Καθ. Νίκο Αγγελούση εξετάζει τις επιδράσεις εξατομικευμένων προγραμμάτων κίνησης στα χαρακτηριστικά βάδισης ασθενών με άνοια.',
        category: 'Έρευνα'
      },
      
      // Article 9: ACL Injury
      aclInjury: {
        title: 'Επεξηγήσιμη Τεχνητή Νοημοσύνη Προσδιορίζει Βιοδείκτες για Τραυματισμό ACL',
        excerpt: 'Ερευνητές της AI4.GR συναναπτύσσουν επεξηγήσιμη μέθοδο μηχανικής μάθησης επιτυγχάνοντας 94.95% ακρίβεια στην ανάλυση προτύπων βάδισης για παράγοντες κινδύνου τραυματισμού ACL.',
        category: 'Έρευνα'
      },
      
      // Article 10: Creative Industries
      creativeIndustries: {
        title: 'Η AI4.GR Συμμετέχει στις Δημιουργικές Βιομηχανίες στο AI X Θεσσαλονίκη',
        excerpt: 'Ο συνιδρυτής Δρ Σεραφείμ Μουστακίδης μιλά σε διακεκριμένο συνέδριο εξερευνώντας πώς η γεννητική τεχνητή νοημοσύνη θα διαμορφώσει τις δημιουργικές βιομηχανίες.',
        category: 'Εκδηλώσεις'
      }
    },
    
    // Common
    common: {
      readMore: 'Διαβάστε Περισσότερα',
      learnMore: 'Μάθετε Περισσότερα',
      getStarted: 'Ξεκινήστε',
      contactUs: 'Επικοινωνήστε μαζί μας',
      loading: 'Φόρτωση...',
      error: 'Σφάλμα',
      notFound: 'Δεν Βρέθηκε',
      backToHome: 'Επιστροφή στην Αρχική'
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let translation = translations[language];
  
  for (const k of keys) {
    if (translation && translation[k]) {
      translation = translation[k];
    } else {
      // Fallback to English if translation not found
      translation = translations.en;
      for (const fallbackKey of keys) {
        if (translation && translation[fallbackKey]) {
          translation = translation[fallbackKey];
        } else {
          return key; // Return the key if no translation found
        }
      }
      break;
    }
  }
  
  return translation || key;
};